import { useEffect, useState } from "react";
import Layout from "../../components/layoutConfig/layout";
import LocalStorage from "../../helpers/localstorage";
import { setupAPIclient } from "../../services/setupAPIclient";
import AgendaWorkspace, { AgendaDoc } from "../../components/agenda/AgendaWorkspace";

export default function AgendaPage() {
  const [docs, setDocs] = useState<AgendaDoc[]>([]);
  const [loading, setLoading] = useState(true);

  const localStorage = new LocalStorage();
  const token = String(localStorage.getAuthToken());

  useEffect(() => {
    const load = async () => {
      try {
        const api = setupAPIclient(token);
        const res = await api.post("/management/get/dashboard");
        setDocs(res.data.docs || []);
      } catch (error) {
        console.error("Erro ao carregar agenda:", error);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [token]);

  return (
    <Layout>
      <AgendaWorkspace docs={docs} loading={loading} />
    </Layout>
  );
}
